(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvEmbeddedEntityPreview', function () {
            return {
                templateUrl: 'app/entity/embedded-entity-preview.tmpl.html',
                scope: {
                    value: '=ngModel',
                    entityTemplateId: '='
                },
                controller: ['$scope', 'EntityTemplatesService', function ($scope, EntityTemplatesService) {
                    var drvCtrl = this;
                    drvCtrl.entity = {};

                    activate();

                    function activate() {
                        drvCtrl.entity.Fields = angular.copy(drvCtrl.value);
                    }

                    function updatePreview() {
                        if (updatePreview.currentPromise === undefined) {
                            updatePreview.currentPromise = null;
                        }
                        drvCtrl.entity.Fields = angular.copy(drvCtrl.value);
                        var getPromise = EntityTemplatesService.getEntityPreview(drvCtrl.entity, drvCtrl.entityTemplateId)
                            .then(getEntityPreviewOk, getEntityPreviewError);

                        updatePreview.currentPromise = getPromise;

                        return getPromise;

                        function getEntityPreviewOk(data) {
                            if (getPromise === updatePreview.currentPromise) {
                                drvCtrl.entityPreview = data;
                            }
                        }

                        function getEntityPreviewError(response) {
                            if (getPromise === updatePreview.currentPromise) {
                                drvCtrl.entityPreview = '<span class="error-messsage-div">' + response.data.Message + '</span>';
                            }
                        }
                    }

                    $scope.$watch(function () {
                        return drvCtrl.value;
                    }, function () {
                        if (!angular.isUndefined(drvCtrl.value) && drvCtrl.value !== null && drvCtrl.value !== '' &&
                            !angular.isUndefined(drvCtrl.entityTemplateId) && drvCtrl.entityTemplateId !== null && drvCtrl.entityTemplateId !== 0) {
                            updatePreview();
                        }
                    });
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    entityTemplateId: '='
                }
            };
        });
})();